import { off } from "process";
import { AgentEvents } from "../agents/BaseAgent";
import { RobotAgent } from "./RobotAgent";
import * as THREE from "three";

export enum RobotViewMode {
  Manual = 'manual',
  Follow = 'follow',
  TopDown = 'topDown'
}

export class RobotViewManager {
  private mode = RobotViewMode.Manual;
  private intercepting = false;
  private offset = new THREE.Vector3(0, 0, 0);
  private defaultCameraUp = new THREE.Vector3(0, 0, 1);
  private siteObj: THREE.Object3D;
  private robotObj: THREE.Object3D;
  constructor(public agent: RobotAgent) {
    this.defaultCameraUp.copy(this.agent.visual.wr.camera.up);
    this.siteObj = this.agent.visual.wr.dataService.activeSite!.obj;
    this.robotObj = this.agent.visual.obj;
  }
  public setMode(mode: RobotViewMode) {
    if (this.mode === mode) {
      return;
    }
    this.mode = mode;
    this.intercepting = false;
    const wr = this.agent.visual.wr;
    this.agent.emit(AgentEvents.ViewManagerChange, mode);
    let cameraPos = new THREE.Vector3();
    if (mode === RobotViewMode.Follow) {
      this.offset.set(-3, -1, 3);
      wr.camera.up.copy(this.defaultCameraUp);
      wr.cameraControls.updateCameraUp();
      cameraPos.copy(this.offset);
      cameraPos = this.robotObj.localToWorld(cameraPos);
    } else if (mode === RobotViewMode.TopDown) {
      this.offset.set(0, 0, 3);
      const upQuat = this.robotObj.getWorldQuaternion(new THREE.Quaternion());
      wr.camera.up.set(1, 0, 0).applyQuaternion(upQuat);
      wr.cameraControls.updateCameraUp();
      cameraPos.copy(this.offset);
      cameraPos = this.robotObj.localToWorld(cameraPos);
    } else if (mode === RobotViewMode.Manual) {

      wr.camera.up.copy(this.defaultCameraUp);
      wr.cameraControls.updateCameraUp();
      
    }
    if (mode !== RobotViewMode.Manual) {
      const target = this.robotObj.getWorldPosition(new THREE.Vector3());
      this.agent.visual.wr.cameraControls
        .setLookAt(
          cameraPos.x, cameraPos.y, cameraPos.z,
          target.x, target.y, target.z, true
        )
        .then(() => this.intercepting = true)
        .catch(console.error);
    }
  }
  public getMode() {
    return this.mode;
  }
  public render(delta: number) {
    if (this.mode === RobotViewMode.Manual || !this.intercepting) {
      return;
    }
    if (this.mode===RobotViewMode.TopDown) { 
      const upQuat = this.robotObj.getWorldQuaternion(new THREE.Quaternion());
      this.agent.visual.wr.camera.up.set(1, 0, 0).applyQuaternion(upQuat);
    }
    let tp = this.robotObj.position.clone();
    let cameraPos = this.offset.clone();
    cameraPos = this.robotObj.localToWorld(cameraPos);
    // cameraPos = cameraPos.applyMatrix4(this.siteObj.matrixWorld);
    tp = tp.applyMatrix4(this.siteObj.matrixWorld);
    const camera = this.agent.visual.wr.camera;
    camera.position.copy(cameraPos);
    camera.lookAt(tp);
  }
}